import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=af5c58a6&lang=html&"
import script from "./Resizer.vue?vue&type=script&lang=js&"
export * from "./Resizer.vue?vue&type=script&lang=js&"
import style0 from "./Resizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports